import { MAIL_ITEM_CONTENT_TYPE } from '../constants';
import AttachmentState from 'owa-attachment-full-data/lib/schema/AttachmentState';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import SmimeAttachmentType from 'owa-attachment-model-store/lib/store/schema/SmimeAttachmentType';
import { ITEM_ATTACHMENT_TYPE } from 'owa-attachment-model-store/lib/utils/attachmentConstants';
import encode from 'owa-encoding-utils/lib/utils/base64/encode';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import item from 'owa-service/lib/factory/item';
import itemAttachment from 'owa-service/lib/factory/itemAttachment';
import mimeContentType from 'owa-service/lib/factory/mimeContentType';

/**
 * Helper function used to add attachments to createItem/updateItem call
 * This is required when we create a non-S/MIME reply for a S/MIME mail containing attachments
 * @param smimeAttachments is the list of attachmentState objects present in attachment well
 * @returns list of AttachmentType object
 */
const getSmimeAttachmentsForRequest = (smimeAttachments: AttachmentState[]): AttachmentType[] => {
    const attachmentsForRequest = smimeAttachments.map(clientAttachment => {
        const attachmentType = getAttachment(clientAttachment.attachmentId)
            .model as SmimeAttachmentType;

        if (attachmentType.__type === ITEM_ATTACHMENT_TYPE && attachmentType.MimeContent) {
            return itemAttachment({
                ...attachmentType,
                Item: item({
                    MimeContent: mimeContentType({
                        Value: encode(attachmentType.MimeContent),
                    }),
                }),
                ContentType: MAIL_ITEM_CONTENT_TYPE,
            });
        } else if (attachmentType.Content) {
            return attachmentType;
        } else {
            return null;
        }
    });

    return attachmentsForRequest.filter(attachmentType => !!attachmentType);
};

export default getSmimeAttachmentsForRequest;
